import React, { FC, HTMLAttributes } from 'react';
import clsx from 'clsx';

import { Typography } from '@common/styles';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { Root } from './ProductName.styled';

/**
 * 상품명 컴포넌트
 * 최대 2줄까지 표시됩니다.
 */
export const ProductName: FC<React.PropsWithChildren<HTMLAttributes<HTMLParagraphElement>>> = ({ className, ...rest }) => {
  const { title } = useProductCardContext();

  return (
    <Root {...rest} className={clsx(className, Typography.CAPTION_12_REGULAR)}>
      {title}
    </Root>
  );
};
